module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cep-user-message"
  }, [_c('div', {
    staticClass: "cep-user-message-body"
  }, [_c('div', {
    staticClass: "cep-user-bubble"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), (_vm.isDebugMode) ? _c('div', {
    staticClass: "cep-debug-bar"
  }, [_c('span', {
    staticClass: "cep-debug-time"
  }, [_vm._v(_vm._s(_vm.formattedTime))]), _vm._v(" "), _c('button', {
    staticClass: "cep-debug-copy",
    class: {
      copied: _vm.copySuccess
    },
    attrs: {
      "title": _vm.copySuccess ? 'Copied' : 'Copy'
    },
    on: {
      "click": _vm.copyMessage
    }
  }, [(!_vm.copySuccess) ? _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('rect', {
    attrs: {
      "x": "9",
      "y": "9",
      "width": "13",
      "height": "13",
      "rx": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
    }
  })]) : _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cep-user-avatar"
  }, [_vm._v(_vm._s(_vm.initials))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5022c8b8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/chat-panel/UserMessage.vue
// module id = U/4F
// module chunks = 1